var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.94V10.3333C1 11.3942 1.42143 12.4116 2.17157 13.1618C2.92172 13.9119 3.93913 14.3333 5 14.3333C6.06087 14.3333 7.07828 13.9119 7.82843 13.1618C8.57857 12.4116 9 11.3942 9 10.3333V3.66667C9 2.95942 8.71905 2.28115 8.21895 1.78105C7.71885 1.28095 7.04058 1 6.33333 1C5.62609 1 4.94781 1.28095 4.44772 1.78105C3.94762 2.28115 3.66667 2.95942 3.66667 3.66667V9.788C3.66667 9.9631 3.70115 10.1365 3.76816 10.2982C3.83517 10.46 3.93338 10.607 4.05719 10.7308C4.181 10.8546 4.32799 10.9528 4.48976 11.0198C4.65152 11.0868 4.8249 11.1213 5 11.1213C5.35362 11.1213 5.69276 10.9809 5.94281 10.7308C6.19286 10.4808 6.33333 10.1416 6.33333 9.788V5",
    stroke: "#045BA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.c8662202f74aaf9c4b6c40dde4ee6c72.svg";
export { ForwardRef as ReactComponent };